import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CarCard } from "@/components/CarCard";
import api from "@/lib/api";

const CATEGORIES = ["All", "Luxury Sedans", "Premium SUVs", "Exotics", "Electric"];

export default function Fleet() {
  const [cars, setCars] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/cars", { params: active === "All" ? {} : { category: active } })
      .then((res) => setCars(res.data))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div className="App bg-slate-50 min-h-screen">
      <Navbar />
      <section className="bg-emerald-950 emerald-grain py-14">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white">Our Fleet</h1>
          <p className="mt-3 text-emerald-100/80 max-w-xl">Choose from luxury sedans, premium SUVs, exotics and electric performance.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 -mt-6">
        <div className="flex flex-wrap gap-2 bg-white rounded-2xl p-2 shadow-md border border-slate-100 w-fit" data-testid="category-filter">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setActive(c)}
              data-testid={`filter-${c.replace(/\s+/g, "-").toLowerCase()}`}
              className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                active === c ? "bg-emerald-900 text-white shadow" : "text-slate-600 hover:bg-emerald-50"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        {loading ? (
          <p className="text-slate-400 py-20 text-center" data-testid="fleet-loading">Loading fleet…</p>
        ) : cars.length === 0 ? (
          <p className="text-slate-400 py-20 text-center" data-testid="fleet-empty">No vehicles in this category.</p>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="fleet-grid">
            {cars.map((car, i) => (
              <CarCard key={car.id} car={car} index={i} />
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
